import { lazy } from 'react';

const Listing = lazy(() => import('./Listing'));

export { Listing };
